import * as React from 'react';

import type { SanityFaqSection } from '#/lib/sanity/queries/sections';

import { FaqAccordion } from './FaqAccordion';
import { Headline } from './Headline';
import { RichText } from './RichText';

export function Faq(props: SanityFaqSection) {
  return (
    <div className="p-main">
      <div className="mx-auto max-w-[980px] justify-between gap-x-50 m:flex">
        <Headline value="FAQ" variant={2} className="mb-30" />
        <FaqAccordion
          questions={props.questions}
          className="max-w-[735px]"
          renderAnswer={(answer) => (
            <RichText value={answer} normalTextSizeClassName="text-body" />
          )}
        />
      </div>
    </div>
  );
}
